<script>
	import { createEventDispatcher } from 'svelte';
	import Icon from '../icons/Icon.svelte';

	const dispatch = createEventDispatcher();

	export let categories = [];
	export let selectedCategoryId = "all";
	export let selectedCategory = { id: "all", name: "Todas as Categorias", active: true };
	export let categoryProducts = [];
	export let phoneCart = [];

	function handleOpenNewCategoryModal() {
		dispatch('openNewCategoryModal');
	}

	function handleOpenEditProductModal(prod) {
		dispatch('openEditProductModal', prod);
	}

	function handleToggleProduct(prod) {
		dispatch('toggleProduct', prod);
	}

	function handlePriceChange(prodId, price) {
		dispatch('updateProductPrice', { prodId, price });
	}

	function handleAddToCart(prod) {
		dispatch('addToPhoneCart', prod);
	}

	function handleSimulatedCheckout() {
		alert('Pedido simulado com sucesso!');
		phoneCart = [];
		dispatch('clearPhoneCart');
	}
</script>

<div class="splitscreen-layout">
			<!-- Lado Esquerdo: Construtor Rápido -->
			<div class="builder-pane">
				<div class="builder-header">
					<h3>Editor Rápido de Itens</h3>
					<div class="builder-cat-selector">
						<label for="split-cat-select">Categoria:</label>
						<select id="split-cat-select" bind:value={selectedCategoryId}>
							<option value="all">Todas as Categorias</option>
							{#each categories as cat}
								<option value={cat.id}>{cat.name}</option>
							{/each}
						</select>
						<button type="button" class="btn-mini-add-cat" on:click={handleOpenNewCategoryModal}>+ Nova</button>
					</div>
				</div>

				<div class="builder-list">
					{#each categoryProducts as prod (prod.id)}
						<div class="builder-item-card">
							<div class="builder-prod-thumb">
								{#if prod.image}
									<img src={prod.image} alt={prod.name} />
								{:else}
									<Icon name="utensils" size={20} color="#94A3B8" />
								{/if}
							</div>
							<div class="builder-card-left">
								<h4>{prod.name}</h4>
								<p>{prod.description}</p>
								<div class="builder-price-input">
									<label for="price-input-{prod.id}">Preço (R$):</label>
									<input
										id="price-input-{prod.id}"
										type="number"
										step="0.01"
										min="0"
										bind:value={prod.price}
										on:change={() => handlePriceChange(prod.id, Number(prod.price))}
									/>
									{#if prod.track_stock}
										<span class="admin-stock-pill {(prod.stock_quantity ?? 0) <= 0 ? 'stock-out' : 'stock-available'}">
											{(prod.stock_quantity ?? 0) <= 0 ? 'Esgotado' : `${prod.stock_quantity} un.`}
										</span>
									{/if}
								</div>
							</div>
							<div class="builder-card-right">
								<button type="button" class="status-pill-toggle {prod.active ? 'active' : 'paused'}" on:click={() => handleToggleProduct(prod)}>
									{prod.active ? "No Cardápio" : "Pausado"}
								</button>
								<button type="button" class="btn-edit-link" on:click={() => handleOpenEditProductModal(prod)}>Editar Detalhes</button>
							</div>
						</div>
					{/each}
				</div>
			</div>

			<!-- Lado Direito: Celular com Cardápio do Cliente ao Vivo -->
			<div class="phone-simulator-pane">
				<div class="phone-frame">
					<div class="phone-notch"></div>
					<div class="phone-screen">
						<!-- Header do Restaurante no Celular -->
						<div class="mobile-header">
							<div class="mobile-brand">
								<div class="mobile-logo-vector">
									<Icon name="utensils" size={18} color="#FFFFFF" />
								</div>
								<div>
									<div class="mobile-title">MataFome Burger Gourmet</div>
									<div class="mobile-meta">Aberto agora • 30-45 min • Entrega R$ 8,00</div>
								</div>
							</div>
						</div>

						<!-- Abas de Categorias no Celular -->
						<div class="mobile-cat-tabs">
							{#each categories.filter(c => c.active) as cat}
								<button
									type="button"
									class="mobile-cat-tab {selectedCategory.id === cat.id ? 'active' : ''}"
									on:click={() => (selectedCategoryId = cat.id)}
								>
									{#if cat.image}
										<img src={cat.image} alt={cat.name} class="mobile-tab-img" />
									{/if}
									<span>{cat.name}</span>
								</button>
							{/each}
						</div>

						<!-- Itens do Cardápio no Celular -->
						<div class="mobile-feed">
							<div class="mobile-cat-banner">
								{#if selectedCategory.image}
									<div class="mobile-banner-img-box">
										<img src={selectedCategory.image} alt={selectedCategory.name} class="mobile-banner-img" />
										<div class="mobile-banner-overlay">
											<span>{selectedCategory.name}</span>
										</div>
									</div>
								{:else}
									<span class="mobile-banner-plain">{selectedCategory.name}</span>
								{/if}
							</div>

							{#each categoryProducts.filter(p => p.active) as prod}
								<div class="mobile-product-card" on:click={() => handleAddToCart(prod)}>
									<div class="mobile-prod-info">
										<h5>{prod.name}</h5>
										<p>{prod.description}</p>
										<span class="mobile-price">
											R$ {(prod.promoPrice > 0 ? prod.promoPrice : prod.price).toFixed(2)}
										</span>
									</div>
									<div class="mobile-prod-right">
										{#if prod.image}
											<img src={prod.image} alt={prod.name} class="mobile-prod-thumb" />
										{/if}
										<button type="button" class="mobile-add-btn">+</button>
									</div>
								</div>
							{/each}
						</div>

						<!-- Barra da Sacola do Celular -->
						{#if phoneCart.length > 0}
							<div class="mobile-cart-bar">
								<div class="cart-left">
									<Icon name="package" size={14} />
									<span>{phoneCart.length} {phoneCart.length === 1 ? 'item' : 'itens'}</span>
								</div>
								<div class="cart-right">
									<span>R$ {phoneCart.reduce((acc, i) => acc + (i.promoPrice > 0 ? i.promoPrice : i.price), 0).toFixed(2)}</span>
									<button type="button" class="btn-checkout" on:click={handleSimulatedCheckout}>
										Ver Pedido
									</button>
								</div>
							</div>
						{/if}
					</div>
				</div>
			</div>
		</div>

<style>
	/* ========================================================
	   LAYOUT 3: SPLIT-SCREEN CELULAR
	   ======================================================== */
	.splitscreen-layout {
		display: flex;
		flex: 1;
		overflow: hidden;
	}

	.builder-pane {
		flex: 1;
		display: flex;
		flex-direction: column;
		background: #FFFFFF;
		border-right: 1px solid #E2E8F0;
		overflow: hidden;
	}

	.builder-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 14px 20px;
		border-bottom: 1px solid #E2E8F0;
	}

	.builder-header h3 {
		margin: 0;
		font-size: 15px;
		font-weight: 700;
		color: #0F172A;
	}

	.builder-cat-selector {
		display: flex;
		align-items: center;
		gap: 8px;
		font-size: 12px;
		color: #475569;
	}

	.builder-cat-selector select {
		padding: 4px 8px;
		border: 1px solid #CBD5E1;
		border-radius: 6px;
		font-size: 12px;
	}

	.builder-list {
		flex: 1;
		overflow-y: auto;
		padding: 16px 20px;
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.builder-item-card {
		display: flex;
		align-items: center;
		gap: 14px;
		padding: 12px 14px;
		background: #F8FAFC;
		border: 1px solid #E2E8F0;
		border-radius: 10px;
	}

	.builder-prod-thumb {
		width: 48px;
		height: 48px;
		border-radius: 8px;
		overflow: hidden;
		background: #FFFFFF;
		border: 1px solid #E2E8F0;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
	}

	.builder-prod-thumb img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.builder-card-left {
		flex: 1;
		min-width: 0;
	}

	.builder-card-left h4 {
		margin: 0 0 2px 0;
		font-size: 14px;
		font-weight: 700;
		color: #0F172A;
	}

	.builder-card-left p {
		margin: 0 0 6px 0;
		font-size: 11px;
		color: #64748B;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.builder-price-input {
		display: flex;
		align-items: center;
		gap: 6px;
		font-size: 12px;
		color: #475569;
	}

	.builder-price-input input {
		width: 70px;
		padding: 3px 6px;
		border: 1px solid #CBD5E1;
		border-radius: 4px;
		font-weight: 700;
	}

	.builder-card-right {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		gap: 6px;
	}

	.status-pill-toggle {
		padding: 4px 10px;
		border-radius: 12px;
		font-size: 11px;
		font-weight: 700;
		border: none;
		cursor: pointer;
	}

	.status-pill-toggle.active {
		background: #DCFCE7;
		color: #166534;
	}

	.status-pill-toggle.paused {
		background: #F1F5F9;
		color: #64748B;
	}

	.btn-edit-link {
		background: transparent;
		border: none;
		color: #FF6A00;
		font-size: 11px;
		font-weight: 700;
		cursor: pointer;
		padding: 0;
	}

	/* Simulador de Celular */
	.phone-simulator-pane {
		width: 420px;
		background: #0F172A;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 24px;
		flex-shrink: 0;
	}

	.phone-frame {
		width: 320px;
		height: 600px;
		background: #FFFFFF;
		border-radius: 36px;
		box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
		border: 10px solid #1E293B;
		position: relative;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}

	.phone-notch {
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		width: 100px;
		height: 18px;
		background: #1E293B;
		border-bottom-left-radius: 12px;
		border-bottom-right-radius: 12px;
		z-index: 50;
	}

	.phone-screen {
		flex: 1;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		background: #F8FAFC;
	}

	.mobile-header {
		padding: 26px 14px 10px 14px;
		background: #FF6A00;
		color: #FFFFFF;
	}

	.mobile-brand {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.mobile-logo-vector {
		width: 28px;
		height: 28px;
		border-radius: 6px;
		background: rgba(255, 255, 255, 0.2);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.mobile-title {
		font-size: 12px;
		font-weight: 700;
	}

	.mobile-meta {
		font-size: 9px;
		opacity: 0.85;
	}

	.mobile-cat-tabs {
		display: flex;
		gap: 6px;
		padding: 8px 12px;
		background: #FFFFFF;
		overflow-x: auto;
		border-bottom: 1px solid #E2E8F0;
	}

	.mobile-cat-tab {
		display: flex;
		align-items: center;
		gap: 4px;
		padding: 3px 8px;
		background: #F1F5F9;
		border: none;
		border-radius: 12px;
		font-size: 10px;
		font-weight: 600;
		white-space: nowrap;
		cursor: pointer;
	}

	.mobile-cat-tab.active {
		background: #FF6A00;
		color: #FFFFFF;
	}

	.mobile-tab-img {
		width: 14px;
		height: 14px;
		border-radius: 50%;
		object-fit: cover;
	}

	.mobile-feed {
		flex: 1;
		overflow-y: auto;
		padding: 10px;
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.mobile-cat-banner {
		margin-bottom: 4px;
	}

	.mobile-banner-img-box {
		position: relative;
		height: 60px;
		border-radius: 8px;
		overflow: hidden;
	}

	.mobile-banner-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.mobile-banner-overlay {
		position: absolute;
		inset: 0;
		background: rgba(0, 0, 0, 0.4);
		display: flex;
		align-items: center;
		justify-content: center;
		color: #FFFFFF;
		font-size: 13px;
		font-weight: 800;
	}

	.mobile-banner-plain {
		font-size: 12px;
		font-weight: 800;
		color: #0F172A;
		display: block;
	}

	.mobile-product-card {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 8px;
		background: #FFFFFF;
		border-radius: 8px;
		border: 1px solid #E2E8F0;
		cursor: pointer;
	}

	.mobile-prod-info h5 {
		margin: 0;
		font-size: 11px;
		font-weight: 700;
		color: #0F172A;
	}

	.mobile-prod-info p {
		margin: 2px 0 4px 0;
		font-size: 9px;
		color: #64748B;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}

	.mobile-price {
		font-size: 11px;
		font-weight: 800;
		color: #FF6A00;
	}

	.mobile-prod-right {
		display: flex;
		align-items: center;
		gap: 6px;
	}

	.mobile-prod-thumb {
		width: 36px;
		height: 36px;
		border-radius: 6px;
		object-fit: cover;
	}

	.mobile-add-btn {
		width: 22px;
		height: 22px;
		border-radius: 50%;
		background: #FFF7ED;
		border: 1px solid #FFEDD5;
		color: #FF6A00;
		font-weight: 800;
		font-size: 13px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.mobile-cart-bar {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 8px 12px;
		background: #0F172A;
		color: #FFFFFF;
		font-size: 11px;
	}

	.cart-left {
		display: flex;
		align-items: center;
		gap: 6px;
	}

	.cart-right {
		display: flex;
		align-items: center;
		gap: 8px;
		font-weight: 700;
	}

	.btn-checkout {
		padding: 4px 8px;
		background: #FF6A00;
		color: #FFFFFF;
		border: none;
		border-radius: 4px;
		font-size: 10px;
		font-weight: 700;
		cursor: pointer;
	}
	.admin-stock-pill {
		display: inline-flex;
		align-items: center;
		gap: 4px;
		font-size: 11px;
		font-weight: 700;
		padding: 2px 7px;
		border-radius: 6px;
		line-height: 1.2;
		white-space: nowrap;
	}

	.admin-stock-pill.stock-available {
		background: #F1F5F9;
		color: #475569;
		border: 1px solid #E2E8F0;
	}

	.admin-stock-pill.stock-out {
		background: #FEE2E2;
		color: #B91C1C;
		border: 1px solid #FECACA;
	}

</style>
